import React from 'react';
import { OSSGroupType } from '../../../utils/enums';
import { checkFeatureFlagForReturnType, getOssReturnTypes } from '../../../utils/featureFlagMappingForReturnType';
import LANGUAGE_CONTROLLER from '../../../controllers/languages';
import { SSelect } from '@avalara/skylab-sdk/react';

const defaultFilterOptions = [
    OSSGroupType.GROUP_EXCLUDE,
    OSSGroupType.GROUP_INCLUDE,
    OSSGroupType.DETAILED,
];

const filterOptionsAsPerReturnType = (returnType) => {
    let filterOptions = [];
    if(getOssReturnTypes().includes(returnType)) {
        filterOptions = defaultFilterOptions;
    }
    return filterOptions;
}

const OSSGroupFilters = (props) => {
    // cases in which nothing should be rendered
    switch (true) {
        case props.returnType === undefined:
        case checkFeatureFlagForReturnType(props.returnType) !== true:
        case getOssReturnTypes().includes(props.returnType) !== true:
            return <></>;
    }

    const filterOptions = filterOptionsAsPerReturnType(props.returnType);

    return (
        <fieldset className="inline" data-testid="oss-group-container">
            <label className="mr5 uppercase">{LANGUAGE_CONTROLLER.format(props.languages, props.labelTextId)}:</label>
            <SSelect
                data-testid="oss-group-filter-select"
                inputId="oss-group-filter-select"
                name="ossGroupFilter"
                className="m4"
                onS-select={(e) => props.onSelect(e?.detail?.item?.value)}
                optionsList={filterOptions.map((filterOption) => ({
                    label: LANGUAGE_CONTROLLER.format(props.languages, filterOption.languageString),
                    value: `${filterOption.value}`,
                    selected: props.value === `${filterOption.value}`
                }))}
                multiple={false}
                showSelectionCount={false}
            />
        </fieldset>
    );
};


export default OSSGroupFilters;
